module.exports = __webpack_public_path__ + "img/yad_yes.2f7830be.png";